//import { ui } from './game.js'
import TWEEN from '@tweenjs/tween.js'
import { getContext, drawImage } from './images.js'
import { scenes, randomJitter } from './game.js'
import { playSfx } from './sfx.js'
import Animation from './animation.js'

var state = 'transition-in'
var selectedIndex = 0
var ctx = null
var elapsed = 0
var menuTitles = {
    'transition-in': '',
    startmenu: '',
    charactermenu: 'CHOOSE CHARACTER',
    levelmenu: 'CHOOSE LEVEL',
    begin: ''
}

var title1 = { x: -100, y: -80 }
var title2 = { x: -100, y: -80 }
var bgTitle = { x: 0, y: -130 }
var shake = {
    screenShakeValue: 0,
    screenShakeDecrementor: 0.03,
    screenShakeFactor: 2,
    levelNumber: 1,
}
var characters = [
    {
        name: 'Sir Cedric',
        portrait: '',
        description: '',
        unlocked: true
    },
    {
        name: '???',
        portrait: '',
        description: '',
        unlocked: false
    },
    {
        name: '???',
        portrait: '',
        description: '',
        unlocked: false
    }
]
var levels = [
    {
        name: 'Slime Forest',
        portrait: '',
        description: '',
        unlocked: true
    },
    {
        name: '???',
        portrait: '',
        description: '',
        unlocked: false
    },
    {
        name: '???',
        portrait: '',
        description: '',
        unlocked: false
    }
]

var menuItems = []

function setState(id) {
    state = id
    menuItems = []
    let items = []
    if (id === 'startmenu') {
        items = ['NEW GAME', 'SETTINGS', 'CREDITS']
        layoutMenuItems(items, 55, 110, 0, 16)
    } else if (id === 'charactermenu') {
        items = characters.map(m => m.name)
        layoutMenuItems(items, 25, 110, 0, 16)
    } else if (id === 'levelmenu') {
        items = levels.map(m => m.name)
        layoutMenuItems(items, 25, 110, 0, 16)
    } else if (id === 'begin') {
        menuItems = []
        scenes.activateScene('game')
        scenes.deActivateScene('character select')
        setState('')
    }
}

/**
 * 
 * @param {array} captions Text labels to lay out.
 * @param {*} baseX 
 * @param {*} baseY 
 * @param {*} incrementX 
 * @param {*} incrementY 
 */
function layoutMenuItems(captions, baseX, baseY, incrementX, incrementY) {
    let dx = baseX
    let dy = baseY
    captions.forEach(caption => {
        menuItems.push({
            text: caption,
            x: dx,
            y: dy
        })
        dx += incrementX
        dy += incrementY
    })
}

function start() {
    selectedIndex = 0
    elapsed = 0
    menuItems = []

    new TWEEN.Tween({ x: 0, y: 0 })
        .to({ x: 0, y: 130 }, 500)
        .easing(TWEEN.Easing.Elastic.In)
        .onUpdate(obj => {
            bgTitle.x = obj.x
            bgTitle.y = obj.y
        })
        .onComplete(() => {
            playSfx('rumble2')
            shake.screenShakeValue = randomJitter(2, 3)
        })
        .start()

    setTimeout(() => new TWEEN.Tween({ x: -50, y: -100})
        .to({ x: 30, y: 10 }, 500)
        .easing(TWEEN.Easing.Elastic.In)
        .onUpdate(obj => {
            title1.x = obj.x
            title1.y = obj.y
        })
        .onComplete(() => {
            shake.screenShakeValue = randomJitter(4, 6)
            playSfx('rumble3')
            setState('startmenu')
        })
        .start(), 500)

    setTimeout(() => new TWEEN.Tween({ x: -50, y: -80})
        .to({ x: 30, y: 50 }, 200)
        .easing(TWEEN.Easing.Elastic.In)
        .onUpdate(obj => {
            title2.x = obj.x
            title2.y = obj.y
        })
        .onComplete(() => {
            shake.screenShakeValue = randomJitter(4, 6)
            playSfx('rumble')
        })
        .start(), 300)

    setState('transition-in')
}

function shadowText(x, y, text, font, fgcolor, shadowColor, bgColr) {
    fgcolor = fgcolor !== undefined ? fgcolor : '#f1f1f1ff'
    shadowColor = shadowColor !== undefined ? shadowColor : '#1d1a59ff'
    bfontjs.DrawText(ctx, x, y + 1, text, shadowColor, bfontjs.Fonts('default'))
    bfontjs.DrawText(ctx, x, y, text, fgcolor, bfontjs.Fonts('default'))
}

function handleInput(input, amt, released) {
    if (['up', 'down'].includes(input) && !amt) {
        playSfx('select')
        selectedIndex += input === 'up' ? -1 : 1
        if (selectedIndex < 0) {
            selectedIndex = menuItems.length - 1
        } else if (selectedIndex >= menuItems.length) {
            selectedIndex = 0
        }
    } else if (state === 'startmenu' && input === 'attack' && !amt) {
        playSfx('selection')
        setState('charactermenu')
    } else if (state === 'charactermenu' && input === 'cancel' && !amt) {
        playSfx('back')
        setState('startmenu')
    } else if (state === 'charactermenu' && input === 'attack' && !amt) {
        if (menuItems[selectedIndex].text !== '???') {
            playSfx('selection')
            setState('levelmenu')
        } else {
            playSfx('playerhurt')
        }
    } else if (state === 'levelmenu' && input === 'attack' && !amt) {
        if (menuItems[selectedIndex].text !== '???') {
            playSfx('selection')
            setState('begin')
        } else {
            playSfx('playerhurt')
        }
    } else if (state === 'levelmenu' && input === 'cancel' && !amt) {
        playSfx('back')
        setState('charactermenu')
    }
}

function handleAnimationFrame(delta) {
    if (!ctx) {
        ctx = getContext()
    }
    elapsed += delta
    ctx.clearRect(0, 0, 200, 187)
    drawImage('titlebg', 0, bgTitle.y - 130)
    drawImage('title1', title1.x, title1.y)
    drawImage('title2', title2.x, title2.y)
    shadowText(15, 95, menuTitles[state], undefined, '#ffe091ff', '#000000ff')

    menuItems.forEach((item, index) => {
        if (index === selectedIndex && elapsed % 500 < 250) {
            drawImage('select-arrow', item.x - 8, item.y + 4)
        }
        shadowText(item.x, item.y, item.text, undefined, '#f1f1f1ff', '#293268ff')
    })

    if (shake.screenShakeValue > 0) {
        ctx.resetTransform()
        ctx.translate(
            Math.floor(randomJitter(-shake.screenShakeValue * shake.screenShakeFactor, shake.screenShakeValue * shake.screenShakeFactor)), 
            Math.floor(randomJitter(-shake.screenShakeValue * shake.screenShakeFactor, shake.screenShakeValue * shake.screenShakeFactor))
        )
    }

    if (state === 'transition-in') {
        TWEEN.update(elapsed)
    }

    shake.screenShakeValue -= delta * shake.screenShakeDecrementor
    if (shake.screenShakeValue < 0) {
        shake.screenShakeValue = 0
        ctx.resetTransform()
    }
}

export { handleAnimationFrame, handleInput, start }